export class AdminUserLogged {

    userId : number = 0;

    email : string | undefined;

    sessionToken : string | undefined;
}